var _excluded = ["options", "onChange", "onClick", "size", "hasError", "errorMessage", "arrowColor", "borderRadius", "isInactive", "optionsAlign", "hasTextEllipsis", "hasOptionsNonBreakingSpace", "hasSelectedOptionWithIcon"];
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext, useEffect, useRef, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import OnColorContext from "../../../contexts/OnColorContext";
import useClickOutside from "../../../hooks/useClickOutside";
import useEscClick from "../../../hooks/useEscClick";
import { focusFirstElementInWrapper } from "../../../hooks/useFocusWrapper";
var TickSvg = function TickSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 1.33 5.057 10 0 5.098l1.374-1.33 3.684 3.57L12.626 0 14 1.33z"
  }));
};
TickSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "10"
};
import { KeyboardEventKeys } from "../../../typings/types";
import IconAtm from "../../atoms/IconAtm";
import TextAtm from "../../atoms/TextAtm";
import FlexContainerOrg from "../../organisms/FlexContainerOrg";
import FlexItemOrg from "../../organisms/FlexItemOrg";
import PushOrg from "../../organisms/PushOrg";
import { Arrow, Aside, Label, Option, Options, optionsBackground, PromoInfo, Select, SelectRefContainer } from "./SelectMol.styled";
import { defaultProps } from "./SelectMol.types";
function SelectMol(_ref) {
  var _options$filter$, _options$filter$2;
  var options = _ref.options,
    onChange = _ref.onChange,
    onClick = _ref.onClick,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? defaultProps.size : _ref$size,
    hasError = _ref.hasError,
    errorMessage = _ref.errorMessage,
    arrowColor = _ref.arrowColor,
    borderRadius = _ref.borderRadius,
    isInactive = _ref.isInactive,
    _ref$optionsAlign = _ref.optionsAlign,
    optionsAlign = _ref$optionsAlign === void 0 ? defaultProps.optionsAlign : _ref$optionsAlign,
    _ref$hasTextEllipsis = _ref.hasTextEllipsis,
    hasTextEllipsis = _ref$hasTextEllipsis === void 0 ? defaultProps.hasTextEllipsis : _ref$hasTextEllipsis,
    hasOptionsNonBreakingSpace = _ref.hasOptionsNonBreakingSpace,
    hasSelectedOptionWithIcon = _ref.hasSelectedOptionWithIcon,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var containerRef = useRef(null);
  var selectRef = useRef(null);
  var optionsRef = useRef(null);
  var onColor = useContext(OnColorContext);
  var selectedOptionValue = (_options$filter$ = options.filter(function (_ref2) {
    var isSelected = _ref2.isSelected;
    return !!isSelected;
  })[0]) === null || _options$filter$ === void 0 ? void 0 : _options$filter$.value;
  var firstNotDisabledOptionValue = (_options$filter$2 = options.filter(function (_ref3) {
    var isDisabled = _ref3.isDisabled;
    return !isDisabled;
  })[0]) === null || _options$filter$2 === void 0 ? void 0 : _options$filter$2.value;
  var defaultOptionValue = selectedOptionValue !== null && selectedOptionValue !== void 0 ? selectedOptionValue : firstNotDisabledOptionValue;
  var _useState = useState(defaultOptionValue),
    _useState2 = _slicedToArray(_useState, 2),
    optionValue = _useState2[0],
    setOptionValue = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasHover = _useState4[0],
    setHasHover = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isOpen = _useState6[0],
    setIsOpen = _useState6[1];
  var optionsId = uuidv4();
  useEffect(function () {
    setOptionValue(defaultOptionValue);
  }, [defaultOptionValue]);
  useClickOutside(containerRef, function () {
    return setIsOpen(false);
  });
  useEscClick(containerRef, function () {
    return setIsOpen(false);
  });
  var getOptionLabelByValue = function getOptionLabelByValue(wantedValue) {
    var _options$filter$3;
    return (_options$filter$3 = options.filter(function (_ref4) {
      var value = _ref4.value;
      return value === wantedValue;
    })[0]) === null || _options$filter$3 === void 0 ? void 0 : _options$filter$3.label;
  };
  var getOptionAsideByValue = function getOptionAsideByValue(wantedValue) {
    var _options$filter$4;
    return (_options$filter$4 = options.filter(function (_ref5) {
      var value = _ref5.value;
      return value === wantedValue;
    })[0]) === null || _options$filter$4 === void 0 ? void 0 : _options$filter$4.aside;
  };
  var getOptionPromoInfoByValue = function getOptionPromoInfoByValue(wantedValue) {
    var _options$filter$5;
    return (_options$filter$5 = options.filter(function (_ref6) {
      var value = _ref6.value;
      return value === wantedValue;
    })[0]) === null || _options$filter$5 === void 0 ? void 0 : _options$filter$5.promoInfo;
  };
  var handleSelectClick = function handleSelectClick(event) {
    if (!isInactive) setIsOpen(function (value) {
      return !value;
    });
    if (onClick && !isOpen) {
      onClick(event);
    }
  };
  var handleSelectMouseEnter = function handleSelectMouseEnter() {
    setHasHover(true);
  };
  var handleSelectMouseLeave = function handleSelectMouseLeave() {
    setHasHover(false);
  };
  var handleOptionClick = function handleOptionClick(value, isDisabled) {
    return function (event) {
      if (!isDisabled) {
        setOptionValue(value);
        setIsOpen(false);
        onChange(value, event);
      }
    };
  };
  var asideByValue = getOptionAsideByValue(optionValue);
  var promoInfoByValue = getOptionPromoInfoByValue(optionValue);
  var optionTypography = size === "small" ? "small2" : "medium2_s";
  var selectedOptionTypography = size === "small" ? "small4" : "medium4_s";
  var handleSelectKeyDown = function handleSelectKeyDown(event) {
    if ((event.key === KeyboardEventKeys.ARROW_DOWN || event.key === KeyboardEventKeys.ENTER || event.key === KeyboardEventKeys.SPACE) && !isOpen) {
      event.preventDefault();
      handleSelectClick(event);
      setTimeout(function () {
        focusFirstElementInWrapper(optionsRef.current);
      }, 100);
    }
  };
  var _getFocusableOption = function getFocusableOption(activeElement, direction) {
    var siblingElement = direction === "next" ? activeElement === null || activeElement === void 0 ? void 0 : activeElement.nextElementSibling : activeElement === null || activeElement === void 0 ? void 0 : activeElement.previousElementSibling;
    if (siblingElement && !siblingElement.ariaDisabled) {
      return siblingElement;
    }
    return siblingElement ? _getFocusableOption(siblingElement, direction) : undefined;
  };
  var handleOptionKeyDown = function handleOptionKeyDown(event, index) {
    if (event.key === KeyboardEventKeys.ARROW_DOWN) {
      var _getFocusableOption2;
      event.preventDefault();
      (_getFocusableOption2 = _getFocusableOption(document.activeElement, "next")) === null || _getFocusableOption2 === void 0 || _getFocusableOption2.focus();
    }
    if (event.key === KeyboardEventKeys.ARROW_UP) {
      var _getFocusableOption3;
      event.preventDefault();
      (_getFocusableOption3 = _getFocusableOption(document.activeElement, "prev")) === null || _getFocusableOption3 === void 0 || _getFocusableOption3.focus();
    }
    if (event.key === KeyboardEventKeys.TAB) {
      setIsOpen(false);
    }
    if (event.key === KeyboardEventKeys.ENTER || event.key === KeyboardEventKeys.SPACE) {
      var _selectRef$current;
      event.preventDefault();
      var _options$index = options[index],
        value = _options$index.value,
        isDisabled = _options$index.isDisabled;
      handleOptionClick(value, isDisabled)(event);
      (_selectRef$current = selectRef.current) === null || _selectRef$current === void 0 || _selectRef$current.focus();
    }
    if (event.key === KeyboardEventKeys.ESC) {
      var _selectRef$current2;
      setIsOpen(false);
      (_selectRef$current2 = selectRef.current) === null || _selectRef$current2 === void 0 || _selectRef$current2.focus();
    }
  };
  return /*#__PURE__*/React.createElement("div", restProps, /*#__PURE__*/React.createElement(SelectRefContainer, {
    ref: containerRef
  }, /*#__PURE__*/React.createElement(Select, {
    $hasHover: hasHover,
    $hasFocus: isOpen,
    $hasError: !!hasError,
    $size: size,
    $onColor: onColor,
    $borderRadius: borderRadius,
    $isInactive: isInactive,
    ref: selectRef,
    onClick: handleSelectClick,
    onMouseEnter: handleSelectMouseEnter,
    onMouseLeave: handleSelectMouseLeave,
    onKeyDown: handleSelectKeyDown,
    tabIndex: 0,
    role: "combobox",
    "aria-expanded": isOpen,
    "aria-haspopup": "listbox",
    "aria-controls": optionsId
  }, /*#__PURE__*/React.createElement(FlexContainerOrg, {
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(FlexItemOrg, {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0
  }, /*#__PURE__*/React.createElement(FlexContainerOrg, {
    direction: "column",
    justifyContent: "flex-start"
  }, /*#__PURE__*/React.createElement(FlexContainerOrg, {
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Label, {
    $typography: optionTypography,
    $hasTextEllipsis: hasTextEllipsis
  }, getOptionLabelByValue(optionValue)), asideByValue ? /*#__PURE__*/React.createElement(Aside, null, asideByValue) : null), promoInfoByValue ? /*#__PURE__*/React.createElement(PromoInfo, null, promoInfoByValue) : null)), /*#__PURE__*/React.createElement(Arrow, {
    $isOpen: !!isOpen,
    $arrowColor: arrowColor
  }))), isOpen ? /*#__PURE__*/React.createElement(Options, {
    $onColor: onColor,
    $align: optionsAlign,
    ref: optionsRef,
    role: "listbox",
    id: optionsId
  }, /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: optionsBackground
  }, options.map(function (_ref7, index) {
    var value = _ref7.value,
      label = _ref7.label,
      aside = _ref7.aside,
      isDisabled = _ref7.isDisabled,
      isSelected = _ref7.isSelected,
      promoInfo = _ref7.promoInfo;
    var isChecked = isSelected && defaultOptionValue === optionValue || value === optionValue;
    return isChecked && !hasSelectedOptionWithIcon ? null : /*#__PURE__*/React.createElement(Option, {
      onClick: handleOptionClick(value, isDisabled),
      key: value,
      $isDisabled: isDisabled,
      $size: size,
      tabIndex: !isDisabled ? 0 : undefined,
      role: "option",
      "aria-selected": isChecked,
      "aria-disabled": isDisabled,
      onKeyDown: function onKeyDown(event) {
        return handleOptionKeyDown(event, index);
      }
    }, /*#__PURE__*/React.createElement(FlexContainerOrg, {
      justifyContent: "space-between",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(TextAtm, {
      typography: isChecked && hasSelectedOptionWithIcon ? selectedOptionTypography : optionTypography,
      color: isDisabled ? "disabled" : undefined,
      hasNonBreakingSpace: hasOptionsNonBreakingSpace
    }, label), aside || isChecked && hasSelectedOptionWithIcon ? /*#__PURE__*/React.createElement(Aside, null, aside, isChecked && hasSelectedOptionWithIcon ? /*#__PURE__*/React.createElement(PushOrg, {
      leftSpace: 1,
      hasNoReset: true
    }, /*#__PURE__*/React.createElement(IconAtm, {
      icon: TickSvg,
      sizeSpace: 2,
      color: "success"
    })) : null) : null), promoInfo ? /*#__PURE__*/React.createElement(PushOrg, {
      rightSpace: isChecked && hasSelectedOptionWithIcon ? 3 : 0,
      hasNoReset: true
    }, promoInfo) : null);
  }))) : null), errorMessage && hasError ? /*#__PURE__*/React.createElement(PushOrg, {
    topSpace: 1
  }, /*#__PURE__*/React.createElement(TextAtm, {
    typography: "tiny1",
    color: "error"
  }, errorMessage)) : null);
}
export default SelectMol;